import React, { createContext, useMemo } from "react";

import { MixPanel } from "./config";

const mixpanelToken = process.env.REACT_APP_MIXPANEL_TOKEN || "";

type TMixpanelContext = {
  trackAgent: any;
};

interface IMixpanelProps {
  children: React.ReactNode;
}

const MixpanelContext = createContext<TMixpanelContext>({} as TMixpanelContext);

function MixpanelProvider({ children }: IMixpanelProps) {
  const value = useMemo(
    () => ({
      trackAgent: MixPanel.boot(mixpanelToken),
    }),
    []
  );

  return (
    <MixpanelContext.Provider value={value}>
      {children}
    </MixpanelContext.Provider>
  );
}

export { MixpanelContext, MixpanelProvider };
